module.exports = __webpack_public_path__ + "img/covidBanner3.6431b353.jpg";